export function hoverWithDelay(element, hoverWithDelayConfig) {
    if (!hoverWithDelayConfig) {
        return {
            destroy() { },
        };
    }
    const [enter, leave, enterDelay, leaveDelay] = hoverWithDelayConfig;
    let onEnterTimeout;
    let onLeaveTimeout;
    const onEnter = () => {
        clearTimeout(onLeaveTimeout);
        onEnterTimeout = setTimeout(enter, enterDelay);
    };
    const onLeave = () => {
        clearTimeout(onEnterTimeout);
        onLeaveTimeout = setTimeout(leave, leaveDelay);
    };
    element.addEventListener('mouseenter', onEnter);
    element.addEventListener('mouseleave', onLeave);
    return {
        destroy() {
            clearTimeout(onEnterTimeout);
            clearTimeout(onLeaveTimeout);
            element.removeEventListener('mouseenter', onEnter);
            element.removeEventListener('mouseleave', onLeave);
        },
    };
}
